export const MatomoSources = {
  CART: 'Cart',
  BEST_FRIEND: 'Best friend',
  PRODUCT_DETAIL: 'Product Detail Page',
  SEARCH: 'Search Quickresults',
  PROMOTED_PRODUCT: 'Promoted Cart Product',
  ORDER_TEMPLATE: 'Order Template',
  ORDER_TEMPLATE_DETAILS: 'Order Template Details',
  LABEL_LIST: 'Label List',
  ESSENTIAL: 'Essence'
};
